import { Injectable, inject } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';

import { DictionaryType } from '../models/types/dictionary.type';
import { OptionalType } from '../models/types/optional.type';
import { TranslationService } from './translation.service';

@Injectable({
    providedIn: 'root'
})
export class FormControlErrorsService {
    private readonly translationService = inject(TranslationService);

    private errorMessageMap: DictionaryType<(error: any) => { key: string; params?: any }> = {
        required: () => ({ key: 'General.ValidationErrors.Required' }),
        matDatepickerFilter: () => ({ key: 'General.ValidationErrors.InvalidDate' }),
        invalidTime: () => ({ key: 'General.ValidationErrors.InvalidTime' }),
        min: error => ({ key: 'General.ValidationErrors.Min', params: { min: error.min } }),
        max: error => ({ key: 'General.ValidationErrors.Max', params: { max: error.max } }),
        numberMin: error => ({ key: 'General.ValidationErrors.Min', params: { min: error.min } }),
        numberMax: error => ({ key: 'General.ValidationErrors.Max', params: { max: error.max } }),
        numberRange: error => ({ key: 'General.ValidationErrors.NumberRange', params: { min: error.min, max: error.max } }),
        numberInteger: () => ({ key: 'General.ValidationErrors.NumberInteger' }),
        number: () => ({ key: 'General.ValidationErrors.Number' }),
        atLeastOneRequired: () => ({ key: 'GeneralMeeting.AtLeastOneDescriptionRequired' }),
        email: () => ({ key: 'General.ValidationErrors.EnterValidEmail' })
    };

    private readonly errorMessageMapEntries = Object.entries(this.errorMessageMap);

    getErrorMessageObs(errors?: ValidationErrors | null): Observable<OptionalType<string>> {
        if (!errors) {
            return of(undefined);
        }

        for (const [error, translationParams] of this.errorMessageMapEntries) {
            if (!!errors[error] && !!translationParams) {
                const params = translationParams(errors[error]);
                return this.translationService.getText(params.key, params.params);
            }
        }

        return this.translationService.getText('General.ValidationErrors.InvalidField');
    }
}
